var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "license-usage-calendar-widget" },
    [
      _c(
        "div",
        { class: ["calendar-panel", { loading: _setup.loading }] },
        [
          _setup.loading
            ? _c("OverlayLoading", {
                attrs: {
                  color: "var(--text-primary)",
                  background: "transparent",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            _setup.Calendar,
            _vm._b(
              {
                attrs: { "display-period-uom": "month", "item-top": "50px" },
                on: {
                  "click-date": _setup.onClickDay,
                  "period-changed": _setup.onPeriodChanged,
                },
                scopedSlots: _vm._u([
                  {
                    key: "header",
                    fn: function (headerProps) {
                      return [
                        _c(
                          _setup.CalendarHeader,
                          _vm._b(
                            { on: { input: _setup.setShowDate } },
                            "CalendarHeader",
                            { ...headerProps },
                            false
                          )
                        ),
                      ]
                    },
                  },
                  {
                    key: "day-content",
                    fn: function ({ day }) {
                      return [
                        _c(
                          _setup.DayUsagePanel,
                          _vm._b({}, "DayUsagePanel", { day }, false)
                        ),
                      ]
                    },
                  },
                ]),
              },
              "Calendar",
              _setup.calendarProps,
              false
            )
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "calendar-footer" },
            [
              _c("div", { staticClass: "calendar-legend" }, [
                _c("span", [_vm._v("Legend")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "legend-item" },
                  [
                    _c(_setup.UsageTypeEmblem, {
                      attrs: { type: "historical", text: false },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "legend-item-label" }, [
                      _vm._v("Historical Usage"),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "legend-item" },
                  [
                    _c(_setup.UsageTypeEmblem, {
                      attrs: { type: "projected", text: false },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "legend-item-label" }, [
                      _vm._v("Projected Usage"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-form-checkbox",
                {
                  model: {
                    value: _setup.showCourses,
                    callback: function ($$v) {
                      _setup.showCourses = $$v
                    },
                    expression: "showCourses",
                  },
                },
                [_vm._v("Show Courses")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Transition",
        { attrs: { appear: "" } },
        [
          _setup.selectedUsageInfo
            ? _c(_setup.WidgetSidebar, {
                on: {
                  close: _setup.closeSidebar,
                  "delete-invite": _setup.deleteInvite,
                  "remove-student": _setup.removeStudent,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }